import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { VueAxios } from './axios'
import {Modal, notification} from 'ant-design-vue'
import { ACCESS_TOKEN } from "@/store/mutation-types"

/**
 * 【指定 axios的 baseURL】
 * 如果手工指定 baseURL: '/jshERP-boot'
 * 则映射后端域名，通过 vue.config.js
 * @type {*|string}
 */
let apiBaseUrl = window._CONFIG['domianURL'] || "/jshERP-boot";
//console.log("apiBaseUrl= ",apiBaseUrl)
// 创建 axios 实例
const service = axios.create({
  baseURL: apiBaseUrl, // api base_url
  timeout: 300000 // 请求超时时间
})

const err = (error) => {
  if (error.response) {
    let data = error.response.data
    const token = Vue.ls.get(ACCESS_TOKEN)
    switch (error.response.status) {
      case 403:
        notification.error({ message: '系统提示', description: '拒绝访问',duration: 4})
        break
      case 500:
        if(token && data==="loginOut"){
          Modal.error({
            title: '登录已过期',
            content: '很抱歉，登录已过期，请重新登录',
            okText: '重新登录',
            mask: false,
            onOk: () => {
              Vue.ls.remove(ACCESS_TOKEN)
              window.location.reload()
            }
          })
        }
        break
      case 404:
          notification.error({ message: '系统提示', description:'很抱歉，资源未找到!',duration: 4})
        break
      case 504:
        notification.error({ message: '系统提示', description: '网络超时'})
        break
      case 401:
        notification.error({ message: '系统提示', description:'未授权，请重新登录',duration: 4})
        if (token) {
          store.dispatch('Logout').then(() => {
            setTimeout(() => {
              window.location.reload()
            }, 1500)
          })
        }
        break
      default:
        notification.error({
          message: '系统提示',
          description: data.message,
          duration: 4
        })
        break
    }
  }
  return Promise.reject(error)
};

// request interceptor
service.interceptors.request.use(config => {
  let token = Vue.ls.get(ACCESS_TOKEN)
  if (token) {
    // 处理token可能是JSON格式的情况
    if (typeof token === 'string' && token.startsWith('{')) {
      try {
        const tokenObj = JSON.parse(token)
        token = tokenObj.value || token
      } catch (e) {
        // 不是JSON格式，保持原样
      }
    }
    config.headers[ 'X-Access-Token' ] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  // 获取并添加租户ID（vue-ls 的 get 内部自动拼 namespace 前缀，此处传不带前缀的 key）
  const userInfoStr = Vue.ls.get('Login_Userinfo')
  let loginTenantId = null
  if (userInfoStr) {
    try {
      const userInfo = typeof userInfoStr === 'string' ? JSON.parse(userInfoStr) : userInfoStr
      const tenantId = userInfo.value ? userInfo.value.tenantId : userInfo.tenantId
      if (tenantId !== undefined && tenantId !== null) {
        config.headers['X-Tenant-Id'] = tenantId
        loginTenantId = String(tenantId)
      }
      // 注意：不发送 X-Username 头——用户名可能是中文，HTTP 头不允许非 ISO-8859-1 字符，
      // 强行发送会导致 XHR setRequestHeader 抛异常、所有请求失败（print-template 等插件已有 null 容错）
    } catch (e) {
      console.warn('解析用户信息失败', e)
    }
  }
  // 门店查询选项（报表跨租户）：总店在报表页选择门店后携带目标租户头，仅登录租户与设置时一致才生效（后端另有五重校验）
  const storeTenantState = store.state.storeTenant
  if (storeTenantState && storeTenantState.targetTenant && loginTenantId !== null && storeTenantState.loginTenantId === loginTenantId) {
    config.headers['X-Target-Tenant'] = String(storeTenantState.targetTenant)
  }
  return config
},(error) => {
  return Promise.reject(error)
})

// response interceptor
service.interceptors.response.use((response) => {
    return response.data
  }, err)

const installer = {
  vm: {},
  install (Vue, router = {}) {
    Vue.use(VueAxios, router, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}